<template>
  <div class="capturing-state">
    <div class="spinner"></div>
    <p>Capturing bug information...</p>
  </div>
</template>

<script>
export default {
  name: 'CapturingState'
}
</script>

<style scoped>
.capturing-state {
  text-align: center;
  padding: 40px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>